import {customElement, query} from 'lit/decorators.js';
import {LitElement} from "lit";
import {SbkButton} from "@/components/button/button";
import {SbkModal} from "@/components/modal/modal";

@customElement('sbk-leadmanagement-resend-mail')
export class SbkLeadmanagementResendMail extends LitElement {

    @query('form')
    _form!: HTMLFormElement

    @query('#submit')
    _submitButton!: SbkButton

    @query('#cancel')
    _cancelButton!: SbkButton

    protected createRenderRoot() {
        return this;
    }

    connectedCallback() {
        super.connectedCallback();
        this._form.addEventListener('submit', (e: Event) => {
            e.preventDefault()
            this._onSubmit(e);
        });

        this._submitButton.addEventListener('click', (e: Event) => {
            e.preventDefault()
            this._onSubmit(e);
        })

        this._cancelButton.addEventListener('click', this._closeModal)
    }

    _onSubmit(e: Event) {
        fetch(this._form.action, {
            method: this._form.method,
            body: new FormData(this._form),
        }).then((response) => {
            this._closeModal(e);
            if (response.status === 200) {
                this._showModal(e, 'resendSuccessModal')
            } else {
                this._showModal(e, 'resendErrorModal')
            }
        })
    }

    _closeModal(e: Event, modalId = '') {
        let modal: SbkModal | null
        if (modalId) {
            modal = document.querySelector(`#${modalId}`)
        } else {
            modal = this.querySelector('sbk-modal')
        }
        modal?._closeModal(e)
    }

    _showModal(e: Event, modalId: string) {
        const modal: SbkModal | null = document.querySelector(`#${modalId}`)
        modal?._showModal(e)
    }
}
